import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import EventModal from '../Event';
import Header from './Header.js';
import { COLUMNS, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';

const Events = (props) => {
  const { data, modal, onSave, onClose, onOpen, loading } = props;
  
  return (
    <div>
      <EventModal
        modal={modal}
        /* TODO seda vist ei ole vaja */
        title='Event'
        onSave={onSave}
        onClose={onClose}
        onOpen={onOpen}
      />
      <Header onOpen={onOpen}/>
      <ReactTable
        className='-striped -highlight'
        data={data}
        loading={loading}
        getTrProps={(state, rowInfo) => ({
          onClick: e => onOpen(null, rowInfo.original)
        })}
        columns={COLUMNS}
        defaultSorted={DEFAULTSORTED}
        defaultPageSize={DEFAULTPAGESIZE} />
    </div>
  );
};

export  default Events;



// WEBPACK FOOTER //
// ./src/private/admin/components/Events/index.js